import type { ServiceProvider, ServiceContainer } from "../service-container";
import type { ResampleFilterPresetsPool } from "./ResampleFilterPresetsPool";
import { BasePool } from "../pool";
import { BaseResampleFilterFactory } from "./BaseResampleFilterFactory";
import { BaseResampleFilterResolver } from "./BaseResampleFilterResolver";

/**
 * Resample filter service provider.
 * @internal
 */
export const resampleFilterProvider: ServiceProvider = {
  /**
   * Registers entities, related to resample filter, in service container.
   *
   * @param container
   */
  register(container: ServiceContainer) {
    const pool: ResampleFilterPresetsPool = new BasePool();

    // Register filter presets
    pool.add("Robidoux", {
      filterFunctionFactory: "CubicBC",
      // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
      filterFunctionFactoryArgs: [0.37821575509399867, 0.31089212245300067], // [b, c]
      windowFunctionFactory: "Box",
      windowFunctionFactoryArgs: [],
      support: 2,
      scale: 1.1685777620836932,
    });
    pool.add("RobidouxSharp", {
      filterFunctionFactory: "CubicBC",
      filterFunctionFactoryArgs: [0.2620145123990142, 0.3689927438004929], // [b, c]
      windowFunctionFactory: "Box",
      windowFunctionFactoryArgs: [],
      support: 2,
      scale: 1.105822933719019,
    });
    pool.add("Box", {
      filterFunctionFactory: "Box",
      filterFunctionFactoryArgs: [],
      windowFunctionFactory: "Box",
      windowFunctionFactoryArgs: [],
      support: 0.5,
      scale: 0.5,
    });

    container.register("ResampleFilterPresetsPool", pool);

    container.register("ResampleFilterFactory", (c) => {
      return new BaseResampleFilterFactory(
        c.resolve("WeightingFunctionFactoriesPool")
      );
    });

    container.register("ResampleFilterResolver", (c) => {
      return new BaseResampleFilterResolver(
        c.resolve("ResampleFilterPresetsPool"),
        c.resolve("ResampleFilterFactory")
      );
    });
  },
};
